@if (!showAdminLayout) {
  <mat-sidenav-container>
    <mat-sidenav #sidenav class="mat-sidenav">
      <app-header-sidenav (closeSideNav)="closeSidenav()"></app-header-sidenav>
    </mat-sidenav>
    <mat-sidenav-content>
      @if (showHead) {
        <app-header (sideNavToggle)="sidenav.toggle()" [isScrolled]="isScrolled"></app-header>
      }
      <div class="app-content" [ngClass]="{'app-margin': showHead, 'with-content': builderService.bannerContent()}">
        <router-outlet></router-outlet>
        @if (showHead) {
          <app-footer></app-footer>
        }
      </div>
    </mat-sidenav-content>
  </mat-sidenav-container>
} @else {
  <router-outlet />
}
<app-progress-spinner></app-progress-spinner>